// aiagent SSE 通用解析器：POST + fetch ReadableStream（EventSource 不支持 POST，现有 GET 范式不可复用）
// 三个流式接口共用：chat/stream、skills/distill、general_skills/generate
import { agentBody } from './utils'

const safeParse = s => { try { return JSON.parse(s) } catch (e) { return null } }

/**
 * @param {string} url 接口地址（this.$baseUrl.xxx）
 * @param {object} data 业务参数（agentBody 包装前）
 * @param {object} cb { onMessage(evt), onOk(result), onError(msg, kind), disconnectMsg? }
 *   evt = { kind:'think'|'reply'|'tool_call'|'tool_result'|'tool_error'|'stage', content, name? }
 *   onError 的 kind：'error'=服务端错误事件 | 'disconnect'=断连/EOF | 'http'=非200 | 'connect'=请求未发出
 *   disconnectMsg 可选：连接中断（流未收到 ok/error 即断）时的提示文案，
 *   各接口断连语义不同（chat 可重试取缓存 / generate 后台继续执行），默认通用文案
 * @param {AbortSignal} [signal] 取消用（abort 后静默返回，不触发任何回调）
 */
export async function ssePost(url, data, cb, signal) {
  let resp
  try {
    resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', token: localStorage.getItem('token') },
      body: JSON.stringify(agentBody(data)),
      signal
    })
  } catch (e) {
    if (e.name === 'AbortError') return
    return cb.onError('连接失败：' + e.message, 'connect')
  }
  if (!resp.ok) return cb.onError(resp.status === 403 ? '登录态失效或无权限（HTTP 403）' : 'HTTP ' + resp.status, 'http')

  const reader = resp.body.getReader()
  const decoder = new TextDecoder()
  let buf = ''
  let closed = false

  const handleBlock = raw => {
    let event = 'message'
    let payload = ''
    for (const line of raw.split('\n')) {
      if (line.startsWith(':')) continue                          // 心跳注释行（3s 一个），必须忽略
      if (line.startsWith('event:')) event = line.slice(6).trim()
      else if (line.startsWith('data:')) payload += line.replace(/^data:\s?/, '')
    }
    if (!payload) return
    if (event === 'ok') {
      closed = true
      const r = safeParse(payload)
      return r ? cb.onOk(r) : cb.onError('ok 数据解析失败', 'disconnect')
    }
    if (event === 'error') { closed = true; return cb.onError(payload, 'error') }
    const evt = safeParse(payload)
    if (evt) cb.onMessage(evt)
  }

  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      buf += decoder.decode(value, { stream: true })
      const blocks = buf.split('\n\n')   // SSE 事件块以空行分隔
      buf = blocks.pop()                 // 末块可能不完整，留缓冲
      for (const b of blocks) {
        handleBlock(b)
        if (closed) return               // 收到 ok/error 即停止读取
      }
    }
    if (!closed) cb.onError(cb.disconnectMsg || '连接中断，可重试', 'disconnect')
  } catch (e) {
    if (e.name === 'AbortError' || closed) return
    // 网络复位等读取异常与正常 EOF 断连同语义，接口专属提示优先（保留错误细节便于诊断）
    cb.onError(cb.disconnectMsg ? cb.disconnectMsg + '（' + e.message + '）' : '读取中断：' + e.message, 'disconnect')
  }
}
